import React from 'react'
import FormField from '../FormField'
import StripeField from '../StripeField'

import {
  InlineStripeField,
  TransactionsIcon,
  TransactionsText,
  Section,
  Row,
} from './PaymentMethodForm.styles'

interface PaymentMethodFormFields {
  cardName: string
}

const PaymentMethodForm = <FormValues extends PaymentMethodFormFields>() => {
  return (
    <Section>
      <StripeField
        name="cardNumber"
        id="cardNumber"
        label="Card Number"
        type="card-number"
      />
      <FormField<FormValues>
        name="cardName"
        placeholder="Name"
        label="Name on Card"
      />
      <Row>
        <InlineStripeField
          id="cardExpirationDate"
          label="Expiry Date"
          name="cardExpirationDate"
          type="card-expiration"
        />
        <InlineStripeField
          id="cardCvc"
          label="CVC"
          name="cardCvc"
          type="card-cvc"
        />
      </Row>
      <TransactionsText>
        <TransactionsIcon />
        <span>All transactions are securely encrypted by Stripe</span>
      </TransactionsText>
    </Section>
  )
}

export default PaymentMethodForm
